<template>
  <div class="accodion_box accodion_orderlist">
    <!-- TODO is-active 클래스 관련 로직 필요 -->
    <div class="accodion_box_tit is-active">
      <a href="#target_plist" data-toggle="collapse" aria-expanded="true">
        <div class="panel-title">
          <span class="text-uppercase accordion-header-text">주문제품</span>
          <span class="orderlistinfo"
            ><em class="orderinfo"> {{ productsInfo.packName }} </em></span
          >
          <span class="pull-right icon-arr"></span>
        </div>
      </a>
    </div>
    <div
      id="target_plist"
      class="accodion_box_cont0 panel-collapse applicants-panel collapse in"
      role="tabpanel"
      aria-expanded="true"
    >
      <div class="panel-body">
        <div class="box_product product_list-type">
          <div class="product_item cart-thead">
            <div class="product_col-summery">
              <p class="txt_cart-thead">제품</p>
            </div>
            <div class="product_col-panels">
              <p class="txt_cart-thead">옵션</p>
            </div>
            <div class="product_col-panels">
              <p class="txt_cart-thead">수량</p>
            </div>
            <div class="product_col-price box_product-price">
              <p class="txt_cart-thead">단가(원) / 소계(원)</p>
            </div>
            <div class="product_col-del">
              <p class="txt_cart-thead">삭제</p>
            </div>
          </div>
          <product-row
            v-for="(product, productIndex) in productsInfo.products"
            :key="productIndex"
            :product="product"
          />
        </div>
        <slot />
      </div>
    </div>
  </div>
</template>

<script>
import ProductRow from "@/views/order/main/components/Products/ProductRow";

export default {
  name: "OrderProducts",
  components: {
    ProductRow,
  },
  props: {
    productsInfo: {
      type: Object,
      required: true,
      default: () => {
        return {
          products: [
            {
              dose_cnt: 120,
              img_url: "/static/images/thumbs/303694K.jpg",
              item_name: "아세로라C",
              item_sku: "303694K",
              outlink: "https://www.uat.amway.co.kr/p/303694K/mpn",
              promotionYN: "false",
              price: 230,
              total_price: 27600,
            },
          ],
          packName: "마이팩",
        };
      },
    },
  },
  method: {},
  data() {
    return {};
  },
  computed: {},
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/order/main/components/Products/OrderProducts.vue